const Reducer = (state: any, action: any) => {
  switch (action.type) {
    case "SET_SELECTED_EVENT":
      return {
        ...state,
        selectedEvent: action.payload,
      };
    case "SET_EVENTS_LIST": {
      return {
        ...state,
        eventsList: action.payload,
      };
    }
    case "SET_ATTENDEE_CATEGORIES_LIST": {
      return {
        ...state,
        attendeeCategoriesList: action.payload,
      };
    }
    case "SET_ATTENDEE_CATEGORY_ACTION": {
      return {
        ...state,
        attendeeCategoriesList: {
          ...state.attendeeCategoriesList,
          action: action.payload,
        },
      };
    }
    case "ADD_MODIFY_ATTENDEE_CATEGORIES_LIST": {
      return {
        ...state,
        attendeeCategoriesList: {
          ...state.attendeeCategoriesList,
          ...action.payload,
        },
      };
    }
    case "SET_CURRENT_USER": {
      return {
        ...state,
        currentUser: action.payload,
      };
    }
    case "SET_SESSION_LOCATIONS": {
      return {
        ...state,
        sessionLocations: action.payload,
      };
    }
    case "SET_SESSION_RESERVATIONS": {
      return {
        ...state,
        sessionReservations: action.payload,
      };
    }
    case "SET_ALERT_LIST": {
      return {
        ...state,
        alertList: action.payload
      }
    }
    case "SET_SELECTED_ALERT": {
      return {
        ...state,
        selectedAlert: action.payload
      }
    }
    case "SET_SELECTED_RESERVATION_ITEMS": {
      return {
        ...state,
        selectedReservationItems: action.payload
      }
    }
    case "SET_DELETE_RESERVATION_ITEMS": {
      return {
        ...state,
        selectedReserveToDelete: action.payload
      }
    }
    case "SET_HAS_LEAD": {
      return {
        ...state,
        hasLead: action.payload
      }
    }
    case "SET_LEADS_DATA":{
      return {
        ...state,
        leadsData: action.payload
      }
    }
    // case 'ADD_POST':
    //     return {
    //         ...state,
    //         posts: state.posts.concat(action.payload)
    //     };
    // case 'REMOVE_POST':
    //     return {
    //         ...state,
    //         posts: state.posts.filter(post => post.id !== action.payload)
    //     };
    // case 'SET_ERROR':
    //     return {
    //         ...state,
    //         error: action.payload
    //     };
    default:
      return state;
  }
};

export default Reducer;
